import React from 'react';
import { useTranslation } from 'react-i18next';

export type Props = {
    up: number;
    late: number;
    down: number;
};

export const BuildingStatusBars = ({ up, late, down }: Props) => {
    const { t } = useTranslation();

    const totalOnline = up + late + down;
    const width = 39;
    const height = 30;
    return (
        <svg
            width={ width }
            height={ height }
        >
            <line
                x1={ 1 }
                y1={ height }
                x2={ 12 }
                y2={ height }
                stroke="#d0d0d0"
                strokeWidth="1"
            />
            <line
                x1={ 14 }
                y1={ height }
                x2={ 25 }
                y2={ height }
                stroke="#d0d0d0"
                strokeWidth="1"
            />
            <line
                x1={ 27 }
                y1={ height }
                x2={ 38 }
                y2={ height }
                stroke="#d0d0d0"
                strokeWidth="1"
            />
            <line
                x1={ 40 }
                y1={ height }
                x2={ 51 }
                y2={ height }
                stroke="#d0d0d0"
                strokeWidth="1"
            />
            { totalOnline &&
                <g
                    x={ 0 }
                    y={ 0 }
                    width={ 12 }
                    height={ height }
                >
                    <title>
                        { up === totalOnline ? t('BUILDINGS.STATUS_ALL_UP') : t('BUILDINGS.STATUS_SOME_UP', [ up, totalOnline ]) }
                    </title>
                    <rect
                        x={ 1 }
                        y={ height * (totalOnline - up) / totalOnline }
                        width={ 11 }
                        height={ height * up / totalOnline }
                        fill="#00c000"
                    />
                </g>
            }
            { totalOnline &&
                <rect
                    x={ 14 }
                    y={ height * (totalOnline - late) / totalOnline }
                    width={ 11 }
                    height={ height * late / totalOnline }
                    fill="#f0f020"
                    stroke="#d0d020"
                    strokeWidth="1"
                >
                    <title>
                        { t('BUILDINGS.STATUS_N_LATE', [ late ]) }
                    </title>
                </rect>
            }
            { totalOnline &&
                <rect
                    x={ 27 }
                    y={ height * (totalOnline - down) / totalOnline }
                    width={ 11 }
                    height={ height * down / totalOnline }
                    fill="#d00000"
                    stroke="#900000"
                    strokeWidth="1"
                >
                    <title>
                        { t('BUILDINGS.STATUS_N_DOWN', [ down ]) }
                    </title>
                </rect>
            }
        </svg>
    );
};

